<div class="h-full bg-white overflow-hidden relative">
  <!-- Main content area - shifts when panel opens -->
  <div class="h-full overflow-y-auto transition-[margin-right] duration-300"
       [style.margin-right]="sidePanelOpen ? '360px' : '0'">
    <div class="flex items-center pt-5 px-7 gap-2">
      <span class="material-icons text-[var(--primary-dark)] text-[20px]">place</span>
      <span class="text-[16px] font-bold text-[var(--base-text-dark)]">Pin Manager</span>
    </div>

    <div class="flex gap-0 px-7 border-b border-[var(--app-base)] mt-4">
      <a routerLink="all-pins" routerLinkActive="!text-[var(--primary-dark)] !border-[var(--primary-dark)]"
        class="py-3 px-5 text-[13px] font-semibold text-[var(--tertiary-text)] cursor-pointer border-b-2 border-transparent hover:text-[var(--primary-dark)] no-underline transition-colors">All Pins</a>
      <a routerLink="sample-groups" routerLinkActive="!text-[var(--primary-dark)] !border-[var(--primary-dark)]"
        [routerLinkActiveOptions]="{exact: true}"
        class="py-3 px-5 text-[13px] font-semibold text-[var(--tertiary-text)] cursor-pointer border-b-2 border-transparent hover:text-[var(--primary-dark)] no-underline transition-colors">Sample Groups</a>
      <a routerLink="field-inspections" routerLinkActive="!text-[var(--primary-dark)] !border-[var(--primary-dark)]"
        [routerLinkActiveOptions]="{exact: true}"
        class="py-3 px-5 text-[13px] font-semibold text-[var(--tertiary-text)] cursor-pointer border-b-2 border-transparent hover:text-[var(--primary-dark)] no-underline transition-colors">Field Inspections</a>
    </div>

    <router-outlet></router-outlet>
  </div>

  <!-- Side Panel -->
  <div class="fixed right-0 top-[56px] bottom-0 w-[360px] bg-white shadow-[-4px_0_20px_rgba(0,0,0,0.08)] z-[850] transition-transform duration-300 flex flex-col overflow-hidden"
       [class.translate-x-full]="!sidePanelOpen"
       [class.translate-x-0]="sidePanelOpen">
    <!-- Header -->
    <div class="border-t-[3px] border-t-[var(--primary-dark)]">
      <div class="flex items-center gap-2 py-4 px-5 border-b border-[var(--app-base)]">
        <img *ngIf="sidePanelPin?.pinType?.id" [src]="'../../assets/icons/' + pinIcons[sidePanelPin.pinType.id]" class="w-4 h-4" alt="">
        <span class="text-[14px] font-semibold flex-1 leading-none text-[var(--base-text-alt-dark)]">{{panelMode === 'editSample' ? 'Edit Sample' : panelMode === 'editPin' ? 'Edit Pin' : sidePanelTitle}}</span>
        <span class="material-icons cursor-pointer text-[var(--tertiary-text)] text-[20px] rounded-full w-7 h-7 flex items-center justify-center hover:bg-[var(--app-base)]"
              (click)="closeSidePanel()">close</span>
      </div>
    </div>

    <!-- Body: View Mode -->
    <div class="flex-1 overflow-y-auto p-5" *ngIf="sidePanelPin && panelMode === 'view'">
      <div *ngIf="sidePanelPin.description" class="flex mb-3.5">
        <span class="text-xs font-semibold text-[var(--base-text-alt-dark)] w-[110px] shrink-0 pt-0.5">Description:</span>
        <span class="text-sm font-medium text-[var(--base-text-alt-dark)]">{{sidePanelPin.description}}</span>
      </div>
      <div class="flex mb-3.5">
        <span class="text-xs font-semibold text-[var(--base-text-alt-dark)] w-[110px] shrink-0 pt-0.5">Date & Time:</span>
        <span class="text-sm font-medium text-[var(--base-text-alt-dark)]">{{formatDate(sidePanelPin.dateCreated)}}</span>
      </div>
      <div class="flex mb-3.5">
        <span class="text-xs font-semibold text-[var(--base-text-alt-dark)] w-[110px] shrink-0 pt-0.5">Latitude:</span>
        <span class="text-sm font-medium text-[var(--base-text-alt-dark)]">{{sidePanelPin.lat}}</span>
      </div>
      <div class="flex mb-3.5">
        <span class="text-xs font-semibold text-[var(--base-text-alt-dark)] w-[110px] shrink-0 pt-0.5">Longitude:</span>
        <span class="text-sm font-medium text-[var(--base-text-alt-dark)]">{{sidePanelPin.lng}}</span>
      </div>
      <div class="flex mb-3.5">
        <span class="text-xs font-semibold text-[var(--base-text-alt-dark)] w-[110px] shrink-0 pt-0.5">Farm:</span>
        <span class="text-sm font-medium text-[var(--base-text-alt-dark)]">{{sidePanelPin.farm?.name}}</span>
      </div>
      <div class="flex mb-3.5">
        <span class="text-xs font-semibold text-[var(--base-text-alt-dark)] w-[110px] shrink-0 pt-0.5">Field:</span>
        <span class="text-sm font-medium text-[var(--base-text-alt-dark)]">{{sidePanelPin.field?.name}}</span>
      </div>
      <div class="flex mb-3.5">
        <span class="text-xs font-semibold text-[var(--base-text-alt-dark)] w-[110px] shrink-0 pt-0.5">Created By:</span>
        <span class="text-sm font-medium text-[var(--base-text-alt-dark)]">{{sidePanelPin.user?.name}}</span>
      </div>

      <!-- Samples (only for Soil & Soft Tissue) -->
      <ng-container *ngIf="sidePanelPin.pinType?.id === 3 || sidePanelPin.pinType?.id === 4">
        <div class="h-px bg-[var(--app-base)] my-5"></div>
        <div class="text-[15px] font-bold mb-3">Samples</div>
        <div *ngFor="let sample of sidePanelSamples"
             class="bg-[var(--app-base)] rounded-lg py-3 px-3.5 mb-2 cursor-pointer transition-colors hover:bg-[var(--primary-light)]"
             (click)="navigateToSampleGroup(sample)">
          <div class="text-[13px] font-medium text-[var(--base-text-alt-dark)]">
            <strong>Sample:</strong> {{sample.name}} &nbsp;|&nbsp; <strong>Linked Group:</strong> {{sample.groupName || '-'}}
          </div>
          <div class="text-[11px] text-[var(--base-text-alt-dark)] mt-0.5">Created Date: {{formatDate(sample.dateCreated)}}</div>
        </div>
        <div *ngIf="sidePanelSamples.length === 0" class="text-[13px] text-[var(--tertiary-text)]">No samples found.</div>
      </ng-container>

      <!-- Editable fields for Marker, Virtual Consultant, Water, Disease, Pest -->
      <ng-container *ngIf="[1,2,5,6,7].includes(sidePanelPin.pinType?.id)">
        <div class="h-px bg-[var(--app-base)] my-5"></div>
        <div class="mb-4">
          <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Pin Name</label>
          <input type="text" [(ngModel)]="editPinDescription"
            class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white outline-none focus:border-[var(--primary-dark)]">
        </div>
      </ng-container>

      <!-- Editable fields for Yield Estimation -->
      <ng-container *ngIf="sidePanelPin.pinType?.id === 8">
        <div class="h-px bg-[var(--app-base)] my-5"></div>
        <div class="mb-4">
          <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Pin Name</label>
          <input type="text" [(ngModel)]="editPinDescription"
            class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white outline-none focus:border-[var(--primary-dark)]">
        </div>
        <div class="mb-4">
          <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Unit of Measure</label>
          <div class="relative">
            <div (click)="showUnitDropdown = !showUnitDropdown; $event.stopPropagation()"
              class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white cursor-pointer flex items-center justify-between hover:border-[var(--primary-dark)]">
              <span>{{getUnitName(editYieldUnitId) || 'Select unit'}}</span>
              <span class="material-icons text-[18px] text-[var(--tertiary-text)]">expand_more</span>
            </div>
            <div *ngIf="showUnitDropdown"
              class="absolute top-[calc(100%+4px)] left-0 w-full bg-white rounded-lg shadow-[0_8px_24px_rgba(0,0,0,0.12)] border border-[var(--app-base)] py-1 z-[200] max-h-[180px] overflow-y-auto">
              <div *ngFor="let u of unitsOfMeasure" (click)="editYieldUnitId = u.id; showUnitDropdown = false"
                class="py-2 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer hover:bg-[var(--app-base)]">
                {{u.name}} ({{u.abbreviation}})
              </div>
            </div>
          </div>
        </div>
        <div class="mb-4">
          <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Yield Estimation</label>
          <input type="number" [(ngModel)]="editYieldEstimation"
            class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white outline-none focus:border-[var(--primary-dark)]">
        </div>
        <div class="mb-4">
          <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Yield Weighted Value (%)</label>
          <input type="number" [(ngModel)]="editYieldWeightedValue"
            class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white outline-none focus:border-[var(--primary-dark)]">
        </div>
        <div class="mb-4">
          <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Estimation Date</label>
          <input type="date" [(ngModel)]="editYieldEstimationDate"
            class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white outline-none focus:border-[var(--primary-dark)]">
        </div>
      </ng-container>

      <!-- NTester info (read-only) -->
      <ng-container *ngIf="sidePanelPin.pinType?.id === 9">
        <div class="h-px bg-[var(--app-base)] my-5"></div>
        <div *ngIf="sidePanelPin.variety" class="flex mb-2">
          <span class="text-xs font-semibold text-[var(--base-text-alt-dark)] w-[120px] shrink-0">Variety:</span>
          <span class="text-sm font-medium text-[var(--base-text-alt-dark)]">{{sidePanelPin.variety}}</span>
        </div>
        <div *ngIf="sidePanelPin.crop" class="flex mb-2">
          <span class="text-xs font-semibold text-[var(--base-text-alt-dark)] w-[140px] shrink-0">Crop:</span>
          <span class="text-sm font-medium text-[var(--base-text-alt-dark)]">{{sidePanelPin.crop}}</span>
        </div>
        <div *ngIf="sidePanelPin.cultivar" class="flex mb-2">
          <span class="text-xs font-semibold text-[var(--base-text-alt-dark)] w-[140px] shrink-0">Cultivar:</span>
          <span class="text-sm font-medium text-[var(--base-text-alt-dark)]">{{sidePanelPin.cultivar}}</span>
        </div>
        <div *ngIf="sidePanelPin.growthStage" class="flex mb-2">
          <span class="text-xs font-semibold text-[var(--base-text-alt-dark)] w-[140px] shrink-0">Growth Stage:</span>
          <span class="text-sm font-medium text-[var(--base-text-alt-dark)]">{{sidePanelPin.growthStage}}</span>
        </div>
        <div *ngIf="sidePanelPin.totalNitrogen" class="flex mb-2">
          <span class="text-xs font-semibold text-[var(--base-text-alt-dark)] w-[140px] shrink-0">Total Nitrogen:</span>
          <span class="text-sm font-medium text-[var(--base-text-alt-dark)]">{{sidePanelPin.totalNitrogen}}</span>
        </div>
        <div *ngIf="sidePanelPin.medianValue" class="flex mb-2">
          <span class="text-xs font-semibold text-[var(--base-text-alt-dark)] w-[140px] shrink-0">Median Value:</span>
          <span class="text-sm font-medium text-[var(--base-text-alt-dark)]">{{sidePanelPin.medianValue}}</span>
        </div>
        <div *ngIf="sidePanelPin.averageValue" class="flex mb-2">
          <span class="text-xs font-semibold text-[var(--base-text-alt-dark)] w-[140px] shrink-0">Average Value:</span>
          <span class="text-sm font-medium text-[var(--base-text-alt-dark)]">{{sidePanelPin.averageValue}}</span>
        </div>
        <div *ngIf="sidePanelPin.yieldTarget" class="flex mb-2">
          <span class="text-xs font-semibold text-[var(--base-text-alt-dark)] w-[140px] shrink-0">Yield Target:</span>
          <span class="text-sm font-medium text-[var(--base-text-alt-dark)]">{{sidePanelPin.yieldTarget}}</span>
        </div>
        <div *ngIf="sidePanelPin.alreadyApplied" class="flex mb-2">
          <span class="text-xs font-semibold text-[var(--base-text-alt-dark)] w-[140px] shrink-0">Already Applied:</span>
          <span class="text-sm font-medium text-[var(--base-text-alt-dark)]">{{sidePanelPin.alreadyApplied}}</span>
        </div>
        <div *ngIf="sidePanelPin.proteinTarget" class="flex mb-2">
          <span class="text-xs font-semibold text-[var(--base-text-alt-dark)] w-[140px] shrink-0">Protein Target:</span>
          <span class="text-sm font-medium text-[var(--base-text-alt-dark)]">{{sidePanelPin.proteinTarget}}</span>
        </div>
        <div *ngIf="sidePanelPin.nRecommendation" class="flex mb-2">
          <span class="text-xs font-semibold text-[var(--base-text-alt-dark)] w-[140px] shrink-0">N Recommendation:</span>
          <span class="text-sm font-medium text-[var(--base-text-alt-dark)]">{{sidePanelPin.nRecommendation}}</span>
        </div>
      </ng-container>
    </div>

    <!-- Body: Add Sample Mode -->
    <div class="flex-1 overflow-y-auto p-5" *ngIf="sidePanelPin && panelMode === 'addSample'">
      <!-- Sample Name -->
      <div class="mb-4">
        <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Sample *</label>
        <input type="text" [(ngModel)]="sampleName" placeholder="Sample name"
          class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white outline-none focus:border-[var(--primary-dark)] placeholder:text-[var(--base-text-alt-dark)]">
      </div>

      <!-- Soil fields -->
      <ng-container *ngIf="sidePanelPin.pinType?.id === 4">
        <div class="mb-4">
          <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Sample Depth (CM)</label>
          <input type="text" [(ngModel)]="sampleDepth"
            class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white outline-none focus:border-[var(--primary-dark)]">
        </div>
        <div class="mb-4">
          <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Rock %</label>
          <input type="text" [(ngModel)]="rockPercentage"
            class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white outline-none focus:border-[var(--primary-dark)]">
        </div>
      </ng-container>

      <!-- Soft Tissue fields -->
      <ng-container *ngIf="sidePanelPin.pinType?.id === 3">
        <div class="mb-4">
          <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Plant Part</label>
          <select [(ngModel)]="plantPartId"
            class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white outline-none focus:border-[var(--primary-dark)] cursor-pointer">
            <option [ngValue]="null">Select plant part</option>
            <option *ngFor="let pp of plantParts" [ngValue]="pp.id">{{pp.name}}</option>
          </select>
        </div>
      </ng-container>

      <!-- Note -->
      <div class="mb-4">
        <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Note</label>
        <textarea [(ngModel)]="sampleNote" placeholder="Add a note..."
          class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white outline-none focus:border-[var(--primary-dark)] resize-y min-h-[80px] placeholder:text-[var(--base-text-alt-dark)]"></textarea>
      </div>

      <!-- Group -->
      <div class="mb-4">
        <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Group *</label>
        <div class="relative">
          <div (click)="showGroupDropdown = !showGroupDropdown; $event.stopPropagation()"
            class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white cursor-pointer flex items-center justify-between hover:border-[var(--primary-dark)]">
            <span>{{selectedGroup?.name || 'Select a group'}}</span>
            <span class="material-icons text-[18px] text-[var(--tertiary-text)]">expand_more</span>
          </div>
          <div *ngIf="showGroupDropdown"
            class="absolute top-[calc(100%+4px)] left-0 w-full bg-white rounded-lg shadow-[0_8px_24px_rgba(0,0,0,0.12)] border border-[var(--app-base)] py-1 z-[200] max-h-[180px] overflow-y-auto">
            <div *ngFor="let g of groups" (click)="selectGroup(g)"
              class="py-2 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer hover:bg-[var(--app-base)]">
              {{g.name}}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Actions: View Mode -->
    <div class="py-4 px-5 border-t border-[var(--app-base)] flex gap-2.5 flex-wrap" *ngIf="sidePanelPin && panelMode === 'view'">
      <button (click)="deletePin()" *ngIf="sidePanelPin.pinType?.id !== 9" class="py-2.5 px-[18px] rounded-lg text-[13px] font-semibold cursor-pointer border-none flex items-center gap-1.5 bg-[var(--notification-error)] text-white hover:opacity-90">
        <span class="material-icons text-[16px]">delete</span> DELETE PIN
      </button>
      <button (click)="convertToVc()" *ngIf="sidePanelPin.pinType?.id === 1"
        class="py-2.5 px-[18px] rounded-lg text-[13px] font-semibold cursor-pointer flex items-center gap-1.5 bg-white text-[var(--base-text-alt-dark)] border-[1.5px] border-[var(--app-border)] hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
        <span class="material-icons text-[16px]">swap_horiz</span> CONVERT
      </button>
      <button (click)="openVirtualConsultant()" *ngIf="sidePanelPin.pinType?.id === 2"
        class="py-2.5 px-[18px] rounded-lg text-[13px] font-semibold cursor-pointer flex items-center gap-1.5 bg-white text-[var(--base-text-alt-dark)] border-[1.5px] border-[var(--app-border)] hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
        <span class="material-icons text-[16px]">open_in_new</span> OPEN VC
      </button>
      <div class="flex-1"></div>
      <button (click)="openAddSampleForm()" *ngIf="sidePanelPin.pinType?.id === 3 || sidePanelPin.pinType?.id === 4"
        class="py-2.5 px-[18px] rounded-lg text-[13px] font-semibold cursor-pointer flex items-center gap-1.5 bg-white text-[var(--base-text-alt-dark)] border-[1.5px] border-[var(--app-border)] hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
        + ADD SAMPLE
      </button>
      <button (click)="updatePin()" *ngIf="sidePanelPin.pinType?.id !== 3 && sidePanelPin.pinType?.id !== 4 && sidePanelPin.pinType?.id !== 9 && sidePanelPin.pinType?.id !== 10"
        class="py-2.5 px-[18px] rounded-lg text-[13px] font-semibold cursor-pointer border-none flex items-center gap-1.5 bg-[var(--primary-dark)] text-white hover:opacity-90">
        UPDATE PIN
      </button>
    </div>

    <!-- Actions: Add Sample Mode -->
    <div class="py-4 px-5 border-t border-[var(--app-base)] flex gap-2.5" *ngIf="sidePanelPin && panelMode === 'addSample'">
      <button (click)="backToView()"
        class="py-2.5 px-[18px] rounded-lg text-[13px] font-semibold cursor-pointer flex items-center gap-1.5 bg-white text-[var(--base-text-alt-dark)] border-[1.5px] border-[var(--app-border)] hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
        <span class="material-icons text-[16px]">arrow_back</span> Back
      </button>
      <div class="flex-1"></div>
      <button (click)="saveSample()" [disabled]="!sampleName || !selectedGroupId"
        class="py-2.5 px-[18px] rounded-lg text-[13px] font-semibold cursor-pointer border-none flex items-center gap-1.5 bg-[var(--primary-dark)] text-white hover:opacity-90 disabled:opacity-40 disabled:cursor-default">
        Save
      </button>
    </div>

    <!-- Body: Edit Sample Mode -->
    <div class="flex-1 overflow-y-auto p-5" *ngIf="sidePanelPin && panelMode === 'editSample'">
      <!-- Sample Name -->
      <div class="mb-4">
        <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Sample Name *</label>
        <input type="text" [(ngModel)]="editSampleName"
          class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white outline-none focus:border-[var(--primary-dark)]">
      </div>

      <!-- Soil fields -->
      <ng-container *ngIf="sidePanelPin.pinType?.id === 4">
        <div class="mb-4">
          <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Sample Depth (CM)</label>
          <input type="number" [(ngModel)]="editSampleDepth"
            class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white outline-none focus:border-[var(--primary-dark)]">
        </div>
        <div class="mb-4">
          <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Rock %</label>
          <input type="number" [(ngModel)]="editRockPercentage"
            class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white outline-none focus:border-[var(--primary-dark)]">
        </div>
      </ng-container>

      <!-- Soft Tissue fields -->
      <ng-container *ngIf="sidePanelPin.pinType?.id === 3">
        <div class="mb-4">
          <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Growth Stage</label>
          <div class="relative" *ngIf="growthStages.length > 0">
            <div (click)="showGrowthStageDropdown = !showGrowthStageDropdown; $event.stopPropagation()"
              class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white cursor-pointer flex items-center justify-between hover:border-[var(--primary-dark)]">
              <span>{{getGrowthStageName(editGrowthStageLinkId) || 'Select growth stage'}}</span>
              <span class="material-icons text-[18px] text-[var(--tertiary-text)]">expand_more</span>
            </div>
            <div *ngIf="showGrowthStageDropdown"
              class="absolute top-[calc(100%+4px)] left-0 w-full bg-white rounded-lg shadow-[0_8px_24px_rgba(0,0,0,0.12)] border border-[var(--app-base)] py-1 z-[200] max-h-[180px] overflow-y-auto">
              <div (click)="editGrowthStageLinkId = null; showGrowthStageDropdown = false"
                class="py-2 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer hover:bg-[var(--app-base)]">Select growth stage</div>
              <div *ngFor="let gs of growthStages" (click)="editGrowthStageLinkId = gs.id; showGrowthStageDropdown = false"
                class="py-2 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer hover:bg-[var(--app-base)]">
                {{gs.name}} {{gs.cropDescription ? '(' + gs.cropDescription + ')' : ''}}
              </div>
            </div>
          </div>
          <span *ngIf="growthStages.length === 0" class="text-[12px] text-[var(--tertiary-text)]">No growth stages available</span>
        </div>
        <div class="mb-4">
          <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Plant Part</label>
          <div class="relative">
            <div (click)="showPlantPartDropdown = !showPlantPartDropdown; $event.stopPropagation()"
              class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white cursor-pointer flex items-center justify-between hover:border-[var(--primary-dark)]">
              <span>{{getPlantPartName(editPlantPartId) || 'Select plant part'}}</span>
              <span class="material-icons text-[18px] text-[var(--tertiary-text)]">expand_more</span>
            </div>
            <div *ngIf="showPlantPartDropdown"
              class="absolute top-[calc(100%+4px)] left-0 w-full bg-white rounded-lg shadow-[0_8px_24px_rgba(0,0,0,0.12)] border border-[var(--app-base)] py-1 z-[200] max-h-[180px] overflow-y-auto">
              <div (click)="editPlantPartId = null; showPlantPartDropdown = false"
                class="py-2 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer hover:bg-[var(--app-base)]">Select plant part</div>
              <div *ngFor="let pp of plantParts" (click)="editPlantPartId = pp.id; showPlantPartDropdown = false"
                class="py-2 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer hover:bg-[var(--app-base)]">
                {{pp.name}}
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Note -->
      <div class="mb-4">
        <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Note</label>
        <textarea [(ngModel)]="editSampleNote" placeholder="Add a note..."
          class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white outline-none focus:border-[var(--primary-dark)] resize-y min-h-[80px] placeholder:text-[var(--base-text-alt-dark)]"></textarea>
      </div>

      <!-- Group -->
      <div class="mb-4">
        <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Group *</label>
        <div class="relative">
          <div (click)="showEditGroupDropdown = !showEditGroupDropdown; $event.stopPropagation()"
            class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white cursor-pointer flex items-center justify-between hover:border-[var(--primary-dark)]">
            <span>{{editSelectedGroup?.name || 'Select a group'}}</span>
            <span class="material-icons text-[18px] text-[var(--tertiary-text)]">expand_more</span>
          </div>
          <div *ngIf="showEditGroupDropdown"
            class="absolute top-[calc(100%+4px)] left-0 w-full bg-white rounded-lg shadow-[0_8px_24px_rgba(0,0,0,0.12)] border border-[var(--app-base)] py-1 z-[200] max-h-[180px] overflow-y-auto">
            <div *ngFor="let g of groups" (click)="selectEditGroup(g)"
              class="py-2 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer hover:bg-[var(--app-base)]">
              {{g.name}}
            </div>
          </div>
        </div>
      </div>

      <!-- Mark Complete -->
      <label class="flex items-center gap-2 cursor-pointer">
        <input type="checkbox" [(ngModel)]="editIsCompleted" class="w-4 h-4 accent-[var(--primary-dark)]">
        <span class="text-[13px] font-medium text-[var(--base-text-alt-dark)]">Mark as Completed</span>
      </label>
    </div>

    <!-- Actions: Edit Sample Mode -->
    <div class="py-4 px-5 border-t border-[var(--app-base)] flex gap-2.5" *ngIf="sidePanelPin && panelMode === 'editSample'">
      <button (click)="backToView()"
        class="py-2.5 px-[18px] rounded-lg text-[13px] font-semibold cursor-pointer flex items-center gap-1.5 bg-white text-[var(--base-text-alt-dark)] border-[1.5px] border-[var(--app-border)] hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
        <span class="material-icons text-[16px]">arrow_back</span> Back
      </button>
      <button (click)="deleteSample()"
        class="py-2.5 px-[18px] rounded-lg text-[13px] font-semibold cursor-pointer border-none flex items-center gap-1.5 bg-[var(--notification-error)] text-white hover:opacity-90">
        Delete
      </button>
      <div class="flex-1"></div>
      <button (click)="updateSample()" [disabled]="!editSampleName"
        class="py-2.5 px-[18px] rounded-lg text-[13px] font-semibold cursor-pointer border-none flex items-center gap-1.5 bg-[var(--primary-dark)] text-white hover:opacity-90 disabled:opacity-40 disabled:cursor-default">
        Update
      </button>
    </div>
    <!-- Body: Edit Pin Mode -->
    <div class="flex-1 overflow-y-auto p-5" *ngIf="sidePanelPin && panelMode === 'editPin'">
      <!-- Description -->
      <div class="mb-4">
        <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Description *</label>
        <input type="text" [(ngModel)]="editPinDescription"
          class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white outline-none focus:border-[var(--primary-dark)]">
      </div>

      <!-- Yield Estimation fields -->
      <ng-container *ngIf="sidePanelPin.pinType?.id === 8">
        <div class="mb-4">
          <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Unit of Measure</label>
          <div class="relative">
            <div (click)="showUnitDropdown = !showUnitDropdown; $event.stopPropagation()"
              class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white cursor-pointer flex items-center justify-between hover:border-[var(--primary-dark)]">
              <span>{{getUnitName(editYieldUnitId) || 'Select unit'}}</span>
              <span class="material-icons text-[18px] text-[var(--tertiary-text)]">expand_more</span>
            </div>
            <div *ngIf="showUnitDropdown"
              class="absolute top-[calc(100%+4px)] left-0 w-full bg-white rounded-lg shadow-[0_8px_24px_rgba(0,0,0,0.12)] border border-[var(--app-base)] py-1 z-[200] max-h-[180px] overflow-y-auto">
              <div *ngFor="let u of unitsOfMeasure" (click)="editYieldUnitId = u.id; showUnitDropdown = false"
                class="py-2 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer hover:bg-[var(--app-base)]">
                {{u.name}} ({{u.abbreviation}})
              </div>
            </div>
          </div>
        </div>
        <div class="mb-4">
          <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Yield Estimation</label>
          <input type="number" [(ngModel)]="editYieldEstimation"
            class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white outline-none focus:border-[var(--primary-dark)]">
        </div>
        <div class="mb-4">
          <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Yield Weighted Value</label>
          <input type="number" [(ngModel)]="editYieldWeightedValue"
            class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white outline-none focus:border-[var(--primary-dark)]">
        </div>
        <div class="mb-4">
          <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Estimation Date</label>
          <input type="date" [(ngModel)]="editYieldEstimationDate"
            class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white outline-none focus:border-[var(--primary-dark)]">
        </div>
      </ng-container>
    </div>

    <!-- Actions: Edit Pin Mode -->
    <div class="py-4 px-5 border-t border-[var(--app-base)] flex gap-2.5" *ngIf="sidePanelPin && panelMode === 'editPin'">
      <button (click)="backToView()"
        class="py-2.5 px-[18px] rounded-lg text-[13px] font-semibold cursor-pointer flex items-center gap-1.5 bg-white text-[var(--base-text-alt-dark)] border-[1.5px] border-[var(--app-border)] hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
        <span class="material-icons text-[16px]">arrow_back</span> Back
      </button>
      <div class="flex-1"></div>
      <button (click)="updatePin()" [disabled]="!editPinDescription"
        class="py-2.5 px-[18px] rounded-lg text-[13px] font-semibold cursor-pointer border-none flex items-center gap-1.5 bg-[var(--primary-dark)] text-white hover:opacity-90 disabled:opacity-40 disabled:cursor-default">
        Update
      </button>
    </div>
  </div>
</div>
